import * as uuid from "uuid";

// _genUUIDImpl :: Effect String
export function _genUUIDImpl() {
  return uuid.v4();
}

const uuidRegex =
  /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/;

export function isValidUUID(str) {
  return !!uuidRegex.exec(str);
}
